export const environment = {
  production: true,
  disableAuth: false,
  apiBaseUrl: 'https://exam.alarkkan.app',
  examApiBaseUrl: 'https://exam.alarkkan.app/api/api',
  traningAppUrl: 'https://alarkkan.app/api/',
  redirectURL: 'https://exam.alarkkan.app/',
};
  
